import React from 'react';
import DropdownBase from '../DropdownBase';
const base = function () {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'contracts';
  return "".concat(process.env.REACT_APP_BASE_URL, "/").concat(type).concat(process.env.REACT_APP_URL_ENV, "/");
};
const name = 'Execution';
const items = [{
  submenu: true,
  menu: /*#__PURE__*/React.createElement(DropdownBase, {
    submenu: true,
    name: "Contracts",
    items: [{
      link: "".concat(base(), "contract_changes"),
      label: 'Contract Amendments for Review'
    }, {
      link: "".concat(base(), "contracts"),
      label: 'Contracts'
    }, {
      submenu: true,
      menu: /*#__PURE__*/React.createElement(DropdownBase, {
        submenu: true,
        name: "Reports",
        items: [{
          link: "".concat(base(), "low_tolerances"),
          label: 'Low Tolerance Report'
        }, {
          link: "".concat(base(), "contract_brokerage_report"),
          label: 'Monthly Brokerage Report'
        }]
      })
    }]
  })
}, {
  link: "".concat(base(), "schedules"),
  label: 'Contract Schedules'
}, {
  link: "".concat(base(), "direct_orders"),
  label: 'Direct Orders'
}, {
  link: "".concat(base(), "grain_tickets/not_invoiced"),
  label: 'Grain Tickets - Not Invoiced'
}, {
  link: "".concat(base(), "nominations"),
  label: 'Nominations'
}, {
  submenu: true,
  menu: /*#__PURE__*/React.createElement(DropdownBase, {
    submenu: true,
    name: "Trucks",
    items: [{
      link: "".concat(base(), "truck_orders/bulk_cancelation"),
      label: 'Bulk Cancelation'
    }, {
      link: "".concat(base(), "inbound_transfer_uploads"),
      label: 'Inbound Transfer Upload'
    }, {
      link: "".concat(base(), "outbound_truck_uploads"),
      label: 'Outbound Truck Upload'
    }, {
      link: "".concat(base(), "transfers"),
      label: 'Transfer Truck Orders'
    }, {
      link: "".concat(base(), "orders"),
      label: 'Truck Orders'
    }, {
      link: "".concat(base(), "orders_without_contracts"),
      label: 'Truck Orders Without Contracts'
    }, {
      link: "".concat(base(), "weight_entry"),
      label: 'Truck Weight Entry'
    }]
  })
}, {
  link: "".concat(base(), "upcoming_time_slots"),
  label: 'Upcoming Time Slots'
}, {
  submenu: true,
  menu: /*#__PURE__*/React.createElement(DropdownBase, {
    submenu: true,
    name: "Vessels",
    items: [{
      link: "".concat(base(), "purchase_vessel_orders"),
      label: 'Orders - Purchase'
    }, {
      link: "".concat(base(), "sales_vessel_orders"),
      label: 'Orders - Sales'
    }]
  })
}, {
  submenu: true,
  menu: /*#__PURE__*/React.createElement(DropdownBase, {
    submenu: true,
    name: "Maintenance",
    items: [{
      link: "".concat(base(), "tax_rates"),
      label: 'Tax Rates'
    }, {
      link: "".concat(base(), "time_slots"),
      label: 'Time Slot'
    }, {
      link: "".concat(base(), "time_slot_groups"),
      label: 'Time Slot Groups'
    }, {
      link: "".concat(base('entities'), "tms_users"),
      label: 'TMS Users'
    }]
  })
}];
const Contracts = () => /*#__PURE__*/React.createElement(DropdownBase, {
  name: name,
  items: items
});
export default Contracts;